import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import * as modal from "../../util/modal.ts";
import ApiServer from "../../ApiServer.js";
import {recipeCategoriesSyncCache} from "../../mealplanner/mealplannerApi.ts";

import * as FwDatas from "../../FwDatas.ts";
import {SafeString} from "../../handlebars_family.js";
import MAIN_MODAL from "../../mealplanner/modal_recipecategories.mustache";
import TPL_ITEM from "../../mealplanner/modal_recipecategories_item.mustache";

import Icons from "../../svg/Icons.ts"
import { registerDragStart } from "../../lib/FileUtils.ts";
import $ from "../../$.js";


ApiServer.types.CategoryBean.prototype.onDecode=function(json){
  FwDatas.cache(this);
  if(!this.emoji){
    this.emoji = "🏷️"
  }
}
ApiServer.types.CategoryBean.prototype.computedName = function(){
  return this.name || i18n.get("mp.categories."+this.categorySystem);
}

Html.register({
  async recipecatlist(){
    let theModal = modal.openModal(MAIN_MODAL,{categories:await recipeCategoriesSyncCache.need()});
    theModal.on('change','input[name=emoji]',function(event){
      let 
        catNode = $(this).metaIdNode(),
        catFromCache = FwDatas.get(catNode.metaId())

      catFromCache.emoji = $(this).val();
      ApiServer.mpcategoryput(catFromCache,function(cat){
        Html.replaceWith(catNode,TPL_ITEM,cat);
      })
    })
    theModal.onClose=function(){
      recipeCategoriesSyncCache.refresh();
    }
  },
  recipecatclick:function(){
    var input = this.parent().find('input')
    input.focus();
    setTimeout(function(){input.select()},50)
  },
  recipecatdelete:function(){
    let 
      metaId = this.metaId(),
      cat = FwDatas.get(metaId);
    modal.confirmDelete({title:"mp.categoriesaskdelete",message:"mp.categoriesaskdeletetext",yes:"actions.delete"},()=>{
      ApiServer.mpcategorydelete(metaId,function(){
        $('[data-fw-meta-id="'+metaId+'"]').fadeOut(300, function() {
          $(this).remove();
        });
        modal.toast({svg:Icons.recipe.ic_confirmation_toast_saved_recipe,iconStyle:'width:60px',text:i18n.getMustache("mp.categoriesdeleted",cat)})
      })
    });
  },
  recipecataddfield:function(){
    var hiddenTPL = this.prev();
    
    hiddenTPL.prev().append(hiddenTPL.clone()).children().last().show().find('input').focus();
  }
})

registerDragStart(".recipecategoryedit",async function(ev,dropPromiseBuilder){
  var  
    movingNode = $(this),
    potentialDrop = document.querySelectorAll('.recipecategoryedit'),
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    dropNode = $(dropEvent.target).metaIdNode();

  var nodeBefore = null;
  if(dropNode.offset().top + dropNode.height()/2>dropEvent.clientY){
    nodeBefore = dropNode.prev();
    movingNode.detach().insertBefore(dropNode)
  }else{
    nodeBefore = dropNode;
    movingNode.detach().insertAfter(dropNode)
  }
  ApiServer.mpcategoryput(new ApiServer.types.CategoryBean({metaId:movingNode.metaId()}),nodeBefore.metaId()||"$empty",function(cat){
    Html.replaceWith(movingNode,TPL_ITEM,cat);
  })
  recipeCategoriesSyncCache.invalidate()
})


$(document).on('focus','.recipecategoryedit input',function(ev){
  let node = $(this).metaIdNode();
  node.data('original',ev.target.value)
  node.find('[data-fw-onclick="recipecatclick"]').hide();
  node.find('[data-fw-onclick="recipecatdelete"]').show();
})
$(document).on('blur','.recipecategoryedit input',function(ev){
  ev.stopPropagation()
  let 
    node = $(this).parent(".recipecategoryedit"),
    metaId = $(this).metaId(),
    input = $(ev.target),
    name =  input.val().trim();
  if(input.prop('readonly')) return;
  if(recipeCategoriesSyncCache.datas.filter(c=>c.metaId!==metaId).filter(c=>c.computedName()===name).length>0){
    input.addClass('fw-form-invalid-control');
    return;
  }
  
  if(metaId){
    if(node.data('original')!==name){
      let catFromCache = FwDatas.get(metaId)
      catFromCache.name = name;
      ApiServer.mpcategoryput(catFromCache,function(){input.removeClass('fw-form-invalid-control')},function(){input.addClass('fw-form-invalid-control')})
    }
  }else if(name){
    ApiServer.mpcategoryput({name:name},function(cat){
      Html.replaceWith(node,TPL_ITEM,cat)
    });
  }else{
    $(this).parent(".recipecategoryedit").remove()
  }
  setTimeout(function(){
    node.find('[data-fw-onclick="recipecatclick"]').show();
    node.find('[data-fw-onclick="recipecatdelete"]').hide();
  },150)
})
$(document).on('keypress','.recipecategoryedit input',function(ev){
  if(ev.keyCode===13 || ev.keyCode===10){
    ev.preventDefault();
    $(this).blur()
  }
})